"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _mobx = require("mobx");

var _gaEventTracker = _interopRequireDefault(require("../../util/gaEventTracker"));

var _history = _interopRequireDefault(require("../../util/history"));

var _forEach = _interopRequireDefault(require("lodash/forEach"));

var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));

var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));

var _class, _descriptor;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

var TabbedSectionModel = (_class = /*#__PURE__*/function () {
  function TabbedSectionModel(activeTab, showArrows, isCollapsible) {
    _classCallCheck(this, TabbedSectionModel);

    _initializerDefineProperty(this, "activeTab", _descriptor, this);

    _defineProperty(this, "anchorMap", {});

    _defineProperty(this, "replaceState", true);

    _defineProperty(this, "showArrows", false);

    _defineProperty(this, "maxTab", 0);

    _defineProperty(this, "isCollapsible", false);

    this.activeTab = (0, _isUndefined.default)(activeTab) ? 1 : activeTab;
    this.showArrows = showArrows || false;
    this.isCollapsible = isCollapsible || false;
  }

  _createClass(TabbedSectionModel, [{
    key: "changeTab",
    value: function changeTab(tabIndex, shouldPopState, url) {
      if (this.isCollapsible && tabIndex === this.activeTab) {
        // Hide the current tab
        tabIndex = 0;
        url = null;
      } // save next tab to history unless we are completing a popstate event


      if (!shouldPopState && this.replaceState) {
        _history.default.pushState({
          activeTab: tabIndex
        }, "", url);
      }

      this.activeTab = tabIndex;
      (0, _gaEventTracker.default)("tab", "changeTab", "changeTab" + tabIndex);
    }
  }, {
    key: "nextTab",
    value: function nextTab() {
      if (this.activeTab < this.maxTab) {
        this.changeTab(this.activeTab + 1);
      }
    }
  }, {
    key: "previousTab",
    value: function previousTab() {
      if (this.activeTab > 1) {
        this.changeTab(this.activeTab - 1);
      }
    }
  }, {
    key: "updateAnchorMap",
    value: function updateAnchorMap(tabs) {
      var _this = this;

      (0, _forEach.default)(tabs, function (tab) {
        if (tab.props.anchor && !tab.props.hidden) {
          _this.anchorMap["#" + tab.props.anchor] = tab.props.index;
        }
      });
      this.maxTab = tabs.length;
    }
  }, {
    key: "updateHistory",
    value: function updateHistory() {
      var _this2 = this;

      _history.default.replaceState({
        activeTab: this.activeTab
      }, "");

      _history.default.addPopStateListener(function (e) {
        if (e.state) {
          _this2.changeTab(e.state.activeTab, true);
        }
      });

      if (typeof window !== "undefined" && this.anchorMap) {
        if (this.anchorMap[window.location.hash]) {
          this.changeTab(this.anchorMap[window.location.hash], false);
        }
      }
    }
  }]);

  return TabbedSectionModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "activeTab", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "changeTab", [_autobindDecorator.default, _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "changeTab"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "nextTab", [_autobindDecorator.default, _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "nextTab"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "previousTab", [_autobindDecorator.default, _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "previousTab"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateAnchorMap", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "updateAnchorMap"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateHistory", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "updateHistory"), _class.prototype)), _class);
var _default = TabbedSectionModel;
exports.default = _default;